import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import { registerServiceWorker } from "./lib/register-sw";
import { initSentryFrontend } from "./lib/sentry";
import { captureAttribution } from "./lib/attribution";
import { SentryErrorBoundary } from "./components/sentry-error-boundary";

// Init Sentry BEFORE the React tree mounts so the error boundary
// already has a working hub the first time it catches a render error.
// No-op when VITE_SENTRY_DSN is missing.
initSentryFrontend();

// Cattura first-touch di utm_* / gclid / wbraid / gbraid (vedi lib/attribution).
captureAttribution();

createRoot(document.getElementById("root")!).render(
  <SentryErrorBoundary>
    <App />
  </SentryErrorBoundary>,
);

registerServiceWorker();
